const integralRoutes = [
  {
    path: '/integral/detail',
    name: 'IntegralDetail',
    meta: {
      index: 30
    },
    component: () => import('@/views/integral/Detail.vue')
  },
  {
    path: '/integral/mall',
    name: 'IntegralMall',
    meta: {
      index: 20
    },
    component: () => import('@/views/integral/Mall.vue')
  }
]

export default integralRoutes
